import { render, staticRenderFns } from "./mirror.vue?vue&type=template&id=057b378b&scoped=true&"
import script from "./mirror.vue?vue&type=script&lang=js&"
export * from "./mirror.vue?vue&type=script&lang=js&"
import style0 from "./mirror.vue?vue&type=style&index=0&id=057b378b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b378b",
  null
  
)

export default component.exports